import gql from 'graphql-tag';

const MUTATION_REASSIGN_ESIM = gql`
  mutation ReassignEsim($input: ReassignEsimInput!) {
    reassignEsim(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_REASSIGN_ESIM;
